enum PAGES {
  HOME = "/",
  NEW_EVENT = "/new-event",
  NEW_CATEGORY = "/new-category",
  NEW_ITEM = "/new-item",
}

export default PAGES;
